import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { GenericComponentsModule } from '@helios/generic-components'
import { ClarityOpsPanelComponent } from './clarity-ops-panel.component'

@NgModule({
  imports: [CommonModule, GenericComponentsModule],
  declarations: [ClarityOpsPanelComponent],
  exports: [ClarityOpsPanelComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ClarityOpsModule {}

export { ClarityOpsPanelComponent }
